import React from 'react'
import Slider from 'react-slick'
import styles from './styles'

function EmptyNarrow() {
  return null
}

const SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <EmptyNarrow />,
  prevArrow: <EmptyNarrow />,
}

function MultiSlider({ children, ...rest }) {
  return (
    <>
      <Slider {...SETTINGS} {...rest}>
        {children}
      </Slider>
      <style jsx global>
        {styles}
      </style>
    </>
  )
}

export default MultiSlider
